import { render, staticRenderFns } from "./WidgetRoot.vue?vue&type=template&id=06f52714"
import script from "./WidgetRoot.vue?vue&type=script&lang=js"
export * from "./WidgetRoot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports